import MaterialRating from '../../../../../../common/material-rating/material-rating';

type MaterialCardRatingProps = { item: Material };

const MaterialCardRating = ({ item }: MaterialCardRatingProps) => {
    const averageRating = item.averageRating || 0;

    if (!averageRating) {
        return null;
    }

    return <MaterialRating rating={averageRating} voices={item.totalFeedbacks} short />;
};

export default MaterialCardRating;
